import React, { createContext, useState } from 'react'

const LoaderContext = createContext(null)

const LoaderProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)

  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};

export default LoaderProvider
export { LoaderProvider, LoaderContext }
